
const state = {
  campaign_id: undefined,
  copied_to_campaign: false,
  copy_type: '',
  description: '',
  id: null,
  order_item_ad_copy_id: undefined,
  order_item_id: undefined,
  review_status: null,
  tagline: '',
}

export const requiredFields = [
  { key: 'copy_type' },
]

export default state
